// 各路由分組可編輯的角色（key 對應路由 meta.group），SuperAdmin 一律可編輯不需列出
// 所有角色都能檢視這些分組的頁面，只有列出的角色能修改
export const groupEditRoles = {
  "xobject-management": ["Engineer"],
  "revit-engineering": ["Engineer"],
  "customer-management": ["Sales"],
};
